

import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';

export default function SocialProof() {
  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          className="bg-white p-12 rounded-3xl shadow-sm border border-gray-100 relative"
        >
          <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-accent text-white w-12 h-12 rounded-full flex items-center justify-center shadow-lg">
            <Quote size={20} />
          </div>

          <h2 className="text-sm font-bold text-accent tracking-widest mb-8 uppercase">Trusted by teams who care about quality</h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12 border-b border-gray-100 pb-12">
            <div>
              <div className="text-4xl font-bold text-primary mb-2">40%+</div>
              <div className="text-sm text-text-muted">Reduction in ticket rework</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-primary mb-2">Fewer</div>
              <div className="text-sm text-text-muted">"Process redefinition" meetings</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-primary mb-2">More</div>
              <div className="text-sm text-text-muted">Time spent helping, not clarifying</div>
            </div>
          </div>

          <blockquote className="text-2xl font-medium text-primary mb-8 leading-relaxed">
            "We don't have those recurring meetings about ticket quality anymore. It's like having that one person who always catches things—except it's there for every ticket."
          </blockquote>

          <cite className="not-italic text-base text-text-muted font-medium">
            — Engineering Manager, Enterprise Software Company
          </cite>
        </motion.div>
      </div>
    </section>
  );
}
